export const PaymentContext = Object.freeze({
    PAYMENT: 'payment',
    ORDER: 'order',
    CLOSE_ORDER: 'closed_order'
})